import { ToastOptions } from 'ng2-toastr';

export class CustomOption extends ToastOptions {
  animate = 'flyLeft'; // you can pass any options to override defaults

  newestOnTop = false;

  showCloseButton = true;

  dismiss = 'auto';
}



// WEBPACK FOOTER //
// ./src/app/custom-option.ts